<template>
  <div>
    <!-- 卷 -->
    <div class="elasticsearch">
      <Row :gutter="10">
        <Col span="4">
          <Button
            type="primary"
            @click="handleShowAdd"
            v-hasPermission="[
              'permissionsConfigurationManagement:resourcePermission:add_disc'
            ]"
            >{{ $t('aiMonitor.addElasticsearch') }}</Button
          >
        </Col>
      </Row>
    </div>
    <Modal
      v-model="modal"
      :title="$t('aiMonitor.addElasticsearch')"
      width="75%"
      :loading="modalLoading"
      :mask-closable="false"
      :closable="false"
    >
      <Form
        :model="volumeForm"
        :label-width="100"
        ref="volumeForm"
        :rules="ruleValidate"
      >
        <!-- 搜索 -->
        <Row :gutter="16">
          <!-- 云平台 -->
          <!-- <Col span="4">
                        <FormItem :label="$t('permission_configuration_management.group.cloudPlatform')" prop="accountTypeSearchKey" :label-width="60">
                            <Select v-model="volumeForm.accountTypeSearchKey" filterable @on-change="changeAccountTypeSearchKey(volumeForm.accountTypeSearchKey)" :transfer="true" placeholder="">
                                <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col> -->
          <Col span="6">
            <!-- 账户 -->
            <FormItem
              :label="$t('permission_configuration_management.group.account')"
              prop="account"
              :label-width="50"
            >
              <Select
                v-model="volumeForm.account"
                @on-change="changeAccount(volumeForm.account)"
                multiple
                :max-tag-count="1"
                :transfer="true"
                placeholder=""
              >
                <Checkbox
                  v-model="singleAccount"
                  @on-change="selectAccountAll"
                  style="display: block;text-align:right;"
                  >{{ $t("alarms.common.allSelected") }}</Checkbox
                >
                <Option
                  :value="item.id"
                  v-for="(item, index) in accountList"
                  v-bind:key="index"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6" style="z-index: 200">
            <!-- 存储区域 -->
            <FormItem
              :label="$t('permission_configuration_management.group.region')"
              prop="region"
              :label-width="50"
            >
              <Select
                @on-change="changeRegion(volumeForm.region)"
                v-model="volumeForm.region"
                :transfer="true"
                placeholder=""
              >
                <Option
                  :value="item.name"
                  v-for="item in regionList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Button
            type="primary"
            style="float:right;"
            v-show="isShowSearch"
            @click="searchElasticsearchInput()"
            >{{ $t("alarms.common.search") }}</Button
          >
        </Row>
        <Table
          :no-data-text="$t('common.noData')"
          ref="selection"
          :columns="columns"
          :loading="loading"
          :data="queryAccountElasticsearchData"
          :height="400"
          @on-selection-change="getSelection"
        ></Table>
      </Form>
      <div slot="footer">
        <Button @click="handleReset('volumeForm')">{{
          $t("permission_configuration_management.common.cancel")
        }}</Button>
        <Button
          type="primary"
          @click="handleSubmit('volumeForm')"
          :loading="addloading"
          :disabled="isDisable"
          >{{
            $t("permission_configuration_management.common.confirm")
          }}</Button
        >
      </div>
    </Modal>
    <table-elasticsearch
      ref="tableElasticsearchChild"
      :getAccountType="getAccountType"
    ></table-elasticsearch>
  </div>
</template>

<script>
import { getCookie } from "../../../utils/cookieUtil";
import TableElasticsearch from "@/components/ai_monitor/application_configuration/TableElasticsearch";
var tableElasticsearch = TableElasticsearch;
export default {
  name: "AddElasticsearch",
  components: {
    TableElasticsearch
  },
  props: ["getAccountType"],
  data() {
    return {
      accountType: "",
      instanceId: "",
      accountTypeList: [],
      singleAccount: false,
      volumeForm: {
        accountTypeSearchKey: "",
        account: [],
        region: "",
        tags: ""
      },
      accountList: [],
      regionList: [],
      selection: [],
      modal: false,
      isDisable: true,
      modalLoading: true,
      loading: false,
      isShowSearch: false,
      addloading: false,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.region"),
          minWidth: 150,
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.domainName"),
          minWidth: 150,
          key: "domainName"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.elasticsearchVersion"),
          minWidth: 150,
          key: "elasticsearchVersion"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.instanceType"),
          minWidth: 150,
          key: "instanceType"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.instanceCount"),
          minWidth: 150,
          key: "instanceCount"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.volumeType"),
          minWidth: 150,
          key: "volumeType"
        },
        {
          title: this.$t("RAM.AWS.Elasticsearch.volumeSize"),
          minWidth: 150,
          key: "volumeSize"
        }
      ],
      ruleValidate: {
        accountTypeSearchKey: [
          {
            required: true,
            message: this.$t('aiMonitor.selectCloudPlatform'),
            trigger: "change",
            type: "number"
          }
        ],
        account: [
          {
            required: true,
            message: this.$t('aiMonitor.selectAccount'),
            trigger: "change",
            type: "array"
          }
        ],
        region: [
          { required: true, message: this.$t('aiMonitor.selectRegion'), trigger: "change" }
        ]
      },
      queryAccountElasticsearchData: [],
      newQueryAccountElasticsearchDataList: []
    };
  },
  methods: {
    // 父组件调用子组件table内的方法
    queryElasticsearchByGroupId() {
      this.$refs.tableElasticsearchChild.queryDatabasesByApplicationId();
    },
    // 云平台
    queryCloudPlatforms: function() {
      this.$api.account
        .queryCloudPlatformsMSP("userName", getCookie(global.cookieName))
        .then(res => {
          this.accountTypeList = res.data;
        });
    },
    // 切换云平台
    changeAccountTypeSearchKey: function() {
      this.volumeForm.account = [];
      this.volumeForm.region = "";
    },
    handleShowAdd() {
      // 清空表格
      this.modal = true;
      this.queryAccountElasticsearchData = [];
      this.isShowSearch = true;
      this.selectAccountByCloudPlatform();
    },
    //查询账号
    selectAccountByCloudPlatform: function() {
      //   if (this.volumeForm.accountTypeSearchKey == undefined) {
      //     return;
      //   }
      // this.$api.groupAccountRelation
      //   .getAccountByGroupIdAndCloudPlatform({
      //     groupId: this.$route.query.id,
      //     accountType: this.getAccountType
      //   })
      //   .then(res => {
      //     this.accountList = res.data;
      //   });

      this.$api.account
        .queryAccountsByCloudType("userName", getCookie(global.cookieName))
        .then(res => {
          this.accountList = res.data;
          for (var i = 0; i < this.accountList.length; i++) {
            this.accountList[i].name =
              this.accountList[i].name +
              "(" +
              this.accountList[i].accountTypeName +
              ")";
          }
        });
    },
    selectAccountAll() {
      this.volumeForm.account = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.volumeForm.account.push(item.id);
        });
      } else {
        this.volumeForm.account = [];
      }
    },
    // 切换账户
    changeAccount: function(val) {
      if (this.volumeForm.account.length == 0) {
        return;
      }
      // 清空表格
      this.queryAccountElasticsearchData = [];
      this.volumeForm.region = "";
      this.isShowSearch = true;
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
      // this.$api.account
      //   .queryAccountRegionsByAccountIds("accountIds", this.volumeForm.account)
      //   .then(res => {
      //     this.regionList = res.data;
      //   });

      this.$api.account
        .queryAccountRegions("accountId", this.volumeForm.account)
        .then(res => {
          this.regionList = res.data;
        });
    },
    // 切换存储区域
    changeRegion: function() {
      this.queryAccountElasticsearchData = [];
      this.isShowSearch = true;
    },
    getState: function(stateStr) {
      for (var i = 0; i < this.state.length; i++) {
        if (stateStr == this.state[i]) {
          return i;
        }
      }
      return -1;
    },
    // 当前选择checkbox
    getSelection: function(selection) {
      this.selection = selection;
      // 清空数组
      this.newQueryAccountElasticsearchDataList = [];
      for (var i = 0; i < this.selection.length; i++) {
        var TableQueryAccountElasticsearchDataCopy = new Object();
        TableQueryAccountElasticsearchDataCopy.esId = this.selection[i].id;
        TableQueryAccountElasticsearchDataCopy.encrypted = this.selection[
          i
        ].encrypted;
        TableQueryAccountElasticsearchDataCopy.state = this.selection[i].state;
        TableQueryAccountElasticsearchDataCopy.arn = this.selection[i].arn;
        TableQueryAccountElasticsearchDataCopy.domainName = this.selection[
          i
        ].domainName;
        TableQueryAccountElasticsearchDataCopy.elasticsearchVersion = this.selection[
          i
        ].elasticsearchVersion;
        TableQueryAccountElasticsearchDataCopy.instanceCount = this.selection[
          i
        ].instanceCount;
        TableQueryAccountElasticsearchDataCopy.volumeType = this.selection[
          i
        ].volumeType;
        TableQueryAccountElasticsearchDataCopy.volumeSize = this.selection[
          i
        ].volumeSize;
        TableQueryAccountElasticsearchDataCopy.project = this.selection[
          i
        ].project;
        TableQueryAccountElasticsearchDataCopy.isActive = this.selection[
          i
        ].isActive;
        TableQueryAccountElasticsearchDataCopy.name = this.selection[i].name;
        TableQueryAccountElasticsearchDataCopy.region = this.selection[
          i
        ].region;
        TableQueryAccountElasticsearchDataCopy.type = this.selection[i].type;
        TableQueryAccountElasticsearchDataCopy.accountId = this.selection[
          i
        ].accountId;
        this.newQueryAccountElasticsearchDataList.push(
          TableQueryAccountElasticsearchDataCopy
        );
      }
      // 选了数据 可以点击下一步
      if (this.newQueryAccountElasticsearchDataList.length == 0) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    // 点击查询
    searchElasticsearchInput: function() {
      this.loading = true;
      // 根据AccountId查询卷列表
      this.$api.brokerSummary
        .queryElasticSearchByGroup({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          region: this.volumeForm.region,
          accountIds: this.volumeForm.account
        })
        .then(res => {
          this.queryAccountElasticsearchData = res.data;
          this.loading = false;
        });
    },
    // 添加
    handleSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 增加
          this.addloading = true;
          this.$api.brokerSummary
            .createByapplicationEsRelation({
              alertRuleName: this.$route.query.alertRuleName,
              applicationId: this.$route.query.id,
              esDTO: this.newQueryAccountElasticsearchDataList
            })
            .then(res => {
              setTimeout(() => {
                this.$refs.tableElasticsearchChild.queryDatabasesByApplicationId();
                this.$refs[name].resetFields();
                this.modalLoading = false;
                this.$nextTick(() => {
                  this.modalLoading = true;
                });
                this.$Message.success(this.$t('common.addSuccess'));
                this.queryAccountElasticsearchData = [];
                this.newQueryAccountElasticsearchDataList = [];
                this.accountList = [];
                this.regionList = [];
                this.modal = false;
                this.addloading = false;
                this.isDisable = true;
                this.singleAccount = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.modalLoading = false;
          setTimeout(() => {
            this.modalLoading = true;
          }, 0);
          this.$Message.error(this.$t('common.addFail'));
        }
      });
    },
    // 取消
    handleReset: function(name) {
      this.isDisable = true;
      this.modal = false;
      this.singleAccount = false;
      this.accountList = [];
      this.regionList = [];
      this.queryAccountElasticsearchData = [];
      this.newQueryAccountElasticsearchDataList = [];
      this.$refs[name].resetFields();
    }
  }
};
</script>

<style scoped>
/*elasticsearch*/
.elasticsearch {
  width: 100%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_configuration/AddElasticsearch.vue